<template>
  <div>
    <ts-card class="m-t-10">
      <ts-card-wrapper>
        <div class="d-flex justify-content-end">
          <div class="d-flex">
            <ts-input
              v-model="search"
              :placeholder="$t('search')"
              style="width: 250px;"
              class="inline-block"
            />
            <ts-button
              outline
              class="ml-2"
              v-tooltip="$t('filter')"
              @click.prevent="visible = true"
            >
              <i class="fa fa-filter"></i>
            </ts-button>
          </div>
        </div>
        <!-- drawer -->
        <a-drawer
          :title="$t('filter')"
          placement="right"
          :closable="false"
          :visible="visible"
          @close="onCloseDrawer"
          :zIndex="1020"
          width="300px"
        >
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label class="ts-text-xs">{{ $t('homePage.dateRange') }}</label>
                <a-range-picker
                  format="DD-MM-YYYY"
                  :defaultValue="rangeDate"
                  :defaultPickerValue="rangeDate"
                  @change="dateRangeChange"
                >
                  <template slot="renderExtraFooter"></template>
                </a-range-picker>
              </div>
            </div>
          </div>
        </a-drawer>
      </ts-card-wrapper>
      <div class="overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :rowGroup="{
            field: 'invoice_number'
          }"
        >
          <template v-slot="{ record }">
            <td class="ts-whitespace-no-wrap">{{ record.branch_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.invoice_date }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.fee_name_en }}</td>
            <td class="ts-whitespace-no-wrap">{{ record.fee_type_name }}</td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ Math.round(record.discount_amount, 2) }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ Math.round(record.vat_amount, 2) }}
            </td>
            <td class="ts-whitespace-no-wrap text-center">
              {{ Math.round(record.total_amount, 2) }}
            </td>
          </template>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'lodash'
import moment from 'moment'

export default {
  name: 'paymentHistory',
  data() {
    return {
      loading: false,
      visible: false,
      rangeDate: [moment().add(-1, 'Month'), moment()]
    }
  },
  created() {
    this.fetchData()
  },
  computed: {
    ...mapState('home/parentPaymentHistory', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.home.parentPaymentHistory.search
      },
      set(newVal) {
        this.$store.commit('home/parentPaymentHistory/SET_SEARCH', newVal)
        this.$store.commit('home/parentPaymentHistory/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('homePage.branch') },
        { name: this.$t('homePage.invoiceDate') },
        { name: this.$t('homePage.feeName') },
        { name: this.$t('homePage.feeTypeName') },
        { name: this.$t('homePage.discount'), style: 'text-align: center' },
        { name: this.$t('homePage.vat'), style: 'text-align: center' },
        { name: this.$t('homePage.totalAmount'), style: 'text-align: center' }
      ]
    },
    selectedStudent() {
      return this.$store.state.selectedStudent.student_id
    }
  },
  methods: {
    onCloseDrawer() {
      this.visible = false
    },
    fetchData(attributes) {
      this.loading = true

      this.$store
        .dispatch('home/parentPaymentHistory/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(() => {
          this.loading = false
        })
    },
    dateRangeChange(dateRange) {
      this.$store.commit(
        'home/parentPaymentHistory/SET_DATE_FROM',
        dateRange[0].format('DD-MM-YYYY')
      )
      this.$store.commit(
        'home/parentPaymentHistory/SET_DATE_TO',
        dateRange[1].format('DD-MM-YYYY')
      )
      this.fetchData()
    }
  },
  watch: {
    search: debounce(function(search) {
      this.fetchData({ search })
    }, 500),
    selectedStudent: debounce(function() {
      this.fetchData()
    }, 500)
  }
}
</script>
